import PropTypes from "prop-types";
import React from "react";
import getClassNameFactory from "../../utilities/classNames";

var GlobalFooterItem = function GlobalFooterItem(_ref) {
  var href = _ref.href,
      title = _ref.title,
      target = _ref.target,
      rel = _ref.rel,
      ariaLabel = _ref.ariaLabel;
  var getClassName = getClassNameFactory(GlobalFooterItem.displayName);
  return /*#__PURE__*/React.createElement("li", {
    className: getClassName()
  }, /*#__PURE__*/React.createElement("a", {
    className: getClassName({
      descendantName: "inner"
    }),
    target: target,
    href: href,
    "aria-label": ariaLabel,
    rel: rel
  }, title));
};

GlobalFooterItem.displayName = "GlobalFooterItem";
/* eslint-disable max-len */

GlobalFooterItem.propTypes = {
  /**
   * URL.
   */
  href: PropTypes.string.isRequired,

  /**
   * Title of the item.
   */
  title: PropTypes.string.isRequired,

  /**
   * expose the <a> elements 'target' prop  to the components api
   */
  target: PropTypes.string,

  /**
   * Aria label for the link.
   */
  ariaLabel: PropTypes.string,

  /**
   * 'rel' attribute for link
   */
  rel: PropTypes.string
};
/* eslint-enable max-len */

export default GlobalFooterItem;